import { ColDef, ICellRendererParams } from 'ag-grid-community'

const CLAMPED_LINES = 2
const LINE_HEIGHT = 18
const VERTICAL_PADDING = 6

export const CLAMPED_TEXT_ROW_HEIGHT = CLAMPED_LINES * LINE_HEIGHT + 2 * VERTICAL_PADDING

const ClampedTextCellRenderer = ({ value }: ICellRendererParams) => (
  <div
    title={value ?? undefined}
    style={{
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: CLAMPED_LINES,
      overflow: 'hidden',
      whiteSpace: 'normal',
      lineHeight: `${LINE_HEIGHT}px`,
    }}
  >
    {value}
  </div>
)

export const clampedTextColDef: ColDef = {
  cellRenderer: ClampedTextCellRenderer,
  cellStyle: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: VERTICAL_PADDING,
    paddingBottom: VERTICAL_PADDING,
  },
}
